import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const TransporterForm = ({ transporter, onSave, onCancel, loading }) => {
    const [name, setName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [gstin, setGstin] = useState('');
    const [address, setAddress] = useState('');
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        if (transporter) {
            setName(transporter.name || '');
            setContactNumber(transporter.contactNumber || '');
            setGstin(transporter.gstin || '');
            setAddress(transporter.address || '');
            setIsActive(transporter.isActive);
        } else {
            setName('');
            setContactNumber('');
            setGstin('');
            setAddress('');
            setIsActive(true);
        }
    }, [transporter]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({
            ...transporter,
            name,
            contactNumber,
            gstin,
            address,
            isActive
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control type="text" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>GSTIN</Form.Label>
                <Form.Control type="text" value={gstin} onChange={(e) => setGstin(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control as="textarea" rows={3} value={address} onChange={(e) => setAddress(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check type="checkbox" label="Is Active" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            </Form.Group>
            <Button variant="secondary" onClick={onCancel} disabled={loading} className="me-2">Cancel</Button>
            <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
            </Button>
        </Form>
    );
};

export default TransporterForm;
